<script>
    import { token } from "../store/token.js";
    import { user } from "../store/user.js";
    import { section } from "../store/section.js";

    let email;
    let error_message;
    let reset_processing_state = false;
    let finished_state = false;

    const handle_password_reset_request = async () => {
        reset_processing_state = true;

        const password_reset_response = await fetch(
            //"https://staging.api.control.vollume.com/admin/login",
            `${process.env.API_ROOT}/user/password/reset`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                }),
            },
        );

        //if (response.code) {
        if (password_reset_response.status != 204) {
            const response = await password_reset_response.json();
            error_message = response.message;
            return;
        }

        finished_state = true;

        //section.set("account/workspaces");

        return;
    };
</script>

<!--
<div class="pres-container">
    <div class="popup-container">
        <div class="popup-card">
            <h1 class="f-2">Login</h1>

            <div class="w-form">
                <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                >
                    <input
                        bind:value={email}
                        type="email"
                        class="field w-input"
                        maxlength="256"
                        name="name"
                        data-name="Name"
                        placeholder="Email"
                        id="name"
                    /><input
                        bind:value={password}
                        type="password"
                        class="field w-input"
                        maxlength="256"
                        name="email-3"
                        data-name="Email 3"
                        placeholder="Password"
                        id="email-3"
                        required=""
                    />
                </form>
                {#if error_message}
                    <div class="w-form-fail">
                        <div>{error_message}</div>
                    </div>{/if}
            </div>
            <div class="popup-actions">
                <div class="button-group-new">
                    <div class="button-group-wrap">
                        <a
                            href="#"
                            class="button button-primary w-button"
                            on:click={() => {
                                try {
                                    handle_login();
                                } catch (e) {
                                    console.log(e);
                                }
                            }}>Login</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
-->
<div class="settings-content">
    <div class="settings-content-holder">
        <div class="text-center">
            <img
                src="../account/images/logo-nav.svg"
                alt="Vollume"
                width="103"
            />
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="text-center">
            <h5>Reset Password</h5>
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="">
            <div class="">
                <div class="card-form-block login-form-holder">
                    <div class="form-group">
                        <input
                            bind:value={email}
                            id="display-name-personal"
                            type="text"
                            name="display-name-personal"
                            placeholder="Enter your Control email"
                            data-required="true"
                        />
                        <div class="error">Enter a valid email</div>
                    </div>

                    {#if error_message}
                        <div class="w-form-fail">
                            <div>{error_message}</div>
                        </div>{/if}

                    <div class="form-group text-md-right">
                        {#if finished_state}
                            <div class="w-100 btn btn-info" href="#">
                                Submitted
                            </div>
                        {:else if reset_processing_state}
                            <div class="w-100 btn btn-primary" href="#">
                                Submitting
                            </div>
                        {:else}
                            <a
                                class="w-100 btn btn-primary"
                                on:click={() => {
                                    try {
                                        handle_password_reset_request();
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                                href="#">Submit</a
                            >
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="text-center">
            Back to <a
                href="#"
                on:click={() => {
                    section.set("public/login");
                }}>Sign In</a
            >
        </div>
    </div>
</div>

<style>
    .login-form-holder {
        max-width: 452px;
        margin: 0 auto;
    }
</style>
